"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.backfillImplementationRulesOutputDtoSchema = exports.backfillImplementationRulesInputDtoSchema = exports.ImplementationRulesBackfillOutcome = void 0;
const z = __importStar(require("zod"));
var ImplementationRulesBackfillOutcome;
(function (ImplementationRulesBackfillOutcome) {
    ImplementationRulesBackfillOutcome["Dispatched"] = "dispatched";
    ImplementationRulesBackfillOutcome["AlreadyInFlight"] = "already_in_flight";
    ImplementationRulesBackfillOutcome["SigmaModelNotEligible"] = "sigma_model_not_eligible";
    ImplementationRulesBackfillOutcome["NoDatasheet"] = "no_datasheet";
    ImplementationRulesBackfillOutcome["DatasheetInvalid"] = "datasheet_invalid";
    ImplementationRulesBackfillOutcome["NotUnderstood"] = "not_understood";
    ImplementationRulesBackfillOutcome["HasRules"] = "has_rules";
    ImplementationRulesBackfillOutcome["UnderstandingInFlight"] = "understanding_in_flight";
})(ImplementationRulesBackfillOutcome || (exports.ImplementationRulesBackfillOutcome = ImplementationRulesBackfillOutcome = {}));
exports.backfillImplementationRulesInputDtoSchema = z.object({
    packageId: z.string(),
});
exports.backfillImplementationRulesOutputDtoSchema = z.object({
    outcome: z.nativeEnum(ImplementationRulesBackfillOutcome),
    workflowId: z.string().nullable(),
    workflowUrl: z.string().nullable(),
});
//# sourceMappingURL=backfill-implementation-rules.dto.js.map